// extracted by mini-css-extract-plugin
export default {"wrapper":"RA-z","addressLine":"SA-z","fullName":"TA-z"};